module.exports = __webpack_public_path__ + "static/img/3-design-b2.dba76cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/3-design-b2.jpg
// module id = +hbr
// module chunks = 0